import React from 'react';
import { WarningCircle } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';

/**
 * ErrorState — la carga de datos ha FALLADO.
 *
 * No confundir con EmptyState ("no hay datos"): si la API devuelve un error
 * (500, 503, red caída…) el usuario tiene que verlo, no una pantalla vacía que
 * parece "todo limpio". Auditoría vibe 2026-10-08 (FE-09).
 *
 * Props:
 *   message: string — texto ya traducido (normalmente parseApiError(...))
 *   onRetry: () => void — opcional; pinta el botón "Reintentar"
 *   testId:  string — data-testid del bloque (por defecto "load-error")
 *   className: string — clases extra para encajarlo en la página
 */
export default function ErrorState({ message, onRetry, testId = 'load-error', className = '' }) {
  if (!message) return null;
  return (
    <div
      role="alert"
      data-testid={testId}
      className={`flex items-center justify-between gap-3 p-3 rounded-md border border-red-500/[0.25] bg-red-500/[0.06] text-sm text-red-300 ${className}`}
    >
      <span className="flex items-center gap-2 min-w-0">
        <WarningCircle className="h-4 w-4 shrink-0" weight="bold" />
        <span className="break-words">{message}</span>
      </span>
      {onRetry ? (
        <Button type="button" size="sm" variant="outline" onClick={onRetry} className="shrink-0 border-red-500/[0.3] text-red-200">
          Reintentar
        </Button>
      ) : null}
    </div>
  );
}
